function getHostName()
{
    const domain = (new URL(window.location.href));
    const hostname = domain.hostname;
    return hostname;
}

function overrideFunctions(settings, components) {
    {   // AutoNavUrl overrides
        const navDelay = settings.Analytics.NavDelay;
        const _base = components.autoNavUrl._responseWatcher;
        const _default = _base.handleProcessedResponse.bind(_base);
       
        _base.handleProcessedResponse = (...args) => {
            const hostname = getHostName();
            setTimeout(() => {
                if (args.length > 0) {
                    if (args[0].response.navUrl != null && args[0].response.navUrl != undefined) {
                        if (window.location.href === `https://${hostname}/tickets/add-ons.html`
                            || window.location.href === `https://${hostname}/tickets/confirmation.html`
                            || window.location.href === `https://${hostname}/tickets/departure.html`
                            || window.location.href === `https://${hostname}/tickets/payment.html`
                            || window.location.href === `https://${hostname}/tickets/travelers.html`) {
                            const confirmAction = confirm(settings.textConstants.AutoNavigationWarning);
                            if (confirmAction) {
                                setTimeout(() => _default(...args), navDelay);
                            }
                        }
                        else
                        {
                            setTimeout(() => _default(...args), navDelay);
                        }
                    }                    
                }

            }, navDelay);

        };

        
    }

    {   // NavUrlResponseHandler overrides
        const navDelay = settings.Analytics.NavDelay;
        // const _base     = components.navUrlResponseHandler;
        const _base = components.navUrlRenderer;
        const _default = _base.urlOnClick.bind(_base);
        _base.urlOnClick = (link, isPopup, response) => {
            components.analyticsHandler.sendLinkAnalytics(link, response);
            setTimeout(() => _default(link, isPopup, response), navDelay);
        };
    }

    {   // LinksResponseHandler overrides
        const navDelay = settings.Analytics.NavDelay;
        // const _base     = components.linksResponseHandler._sectionBuilder._urlLinkBuilder;
        const _base = components.displayLinkRenderer._sectionBuilder._urlLinkBuilder;
        const _default = _base.urlOnClick.bind(_base);
        _base.urlOnClick = (link, response) => {
            components.analyticsHandler.sendLinkAnalytics(link, response);
            setTimeout(() => _default(link, response), navDelay);
        };
    }

    {   // SingleLinkRenderer overrides
        const urlType = settings.navConstants.targetTypes.url;
        const _base = components.singleLinkRenderer._renderers;
        const _default = _base.renderWrappedLink.bind(_base);
        _base.renderWrappedLink = (link, ref, titlePath, spec = {}, resp) => {
            const url = (typeof ref === 'string') ? ref : null;
            // eslint-disable-next-line @typescript-eslint/no-empty-function
            const action = (typeof ref === 'function') ? ref : () => { };
            const isPopup = (spec.target && spec.target !== '_self');
            const isUrlNav = (url || link.TargetType === urlType);
            const newRef = (!isUrlNav) ? ref : () => {
                components.analyticsHandler.sendLinkAnalytics(link, resp);
                setTimeout(() => {
                    (!url) ? action() :
                        (isPopup) ? window.open(url, '_blank')
                            : window.location.href = url;
                }, settings.Analytics.NavDelay);
            };
            return _default(link, newRef, titlePath, spec, resp);
        };
    }
}

export {
    overrideFunctions
};


// WEBPACK FOOTER //
// ./src/overrides.js